import {
  CommonEventDetailId,
  YesNoEnum,
} from '@collector/sportsapi-client-legacy'

import {
  whenCurrentValueIs,
  type SelectOptionDisableRule,
} from './event-detail.utils'

/**
 * Select options disabled for a detail while a condition holds.
 * Has lineups id `205` is shared by every sport that shows the detail.
 */
export const eventDetailSelectDisableRules: SelectOptionDisableRule[] = [
  {
    detailId: CommonEventDetailId.HasLineups,
    option: YesNoEnum.No,
    when: whenCurrentValueIs('probable'),
  },
]
